import api from './api';

export interface RebillCreditListRow {
  recno: number;
  rebillDate: string;
  creditMemoNum: string;
  rebilledInvoice: string;
  deleted: string;
}

export interface RebillCreditListResponse {
  count: number;
  applyToOptions: string[];
  records: RebillCreditListRow[];
}

export interface RebillCreditLineItem {
  recno?: number;
  glCode: string;
  amount: string;
  deleted?: string;
}

export interface RebillCreditRecord {
  recno: number;
  createdBy: string;
  createdAtDisplay: string;
  adjustedRebill: string;
  rebillDate: string;
  creditMemoNum: string;
  rebilledInvoice: string;
  applyTo: string;
  sageTag: string;
  sageTagName: string;
  deptResponsible: string;
  preventable: string;
  comments: string;
  deleted: string;
  applyToOptions: string[];
  lineItems: RebillCreditLineItem[];
}

export type RebillCreditPayload = {
  adjustedRebill: string;
  rebillDate: string;
  creditMemoNum: string;
  rebilledInvoice: string;
  applyTo: string;
  sageTag: string;
  deptResponsible: string;
  preventable: string;
  comments: string;
  deleted: string;
  lineItems: RebillCreditLineItem[];
};

export const rebillCreditService = {
  list: (pronumber: number): Promise<RebillCreditListResponse> =>
    api.get(`/orders/${pronumber}/rebill-credit`).then((r) => r.data),
  get: (pronumber: number, recno: number): Promise<RebillCreditRecord> =>
    api.get(`/orders/${pronumber}/rebill-credit/${recno}`).then((r) => r.data),
  create: (pronumber: number, body: RebillCreditPayload): Promise<{ recno: number }> =>
    api.post(`/orders/${pronumber}/rebill-credit`, body).then((r) => r.data),
  update: (pronumber: number, recno: number, body: RebillCreditPayload): Promise<{ recno: number }> =>
    api.put(`/orders/${pronumber}/rebill-credit/${recno}`, body).then((r) => r.data),
};
